<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '@/mixins/userRole'
import unsavedData from '@/mixins/unsavedData'

export default {
  name: 'ProcurationStep5',
  components: {},
  mixins: [userRole, unsavedData],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      pageloading: false,
      showAddPerson: false,
      loading: false,
      formData: {},
    }
  },
  computed: {
    getId() {
      return this.$route.params.id || null
    },
    modeReadonly() {
      return false
    },
  },
  created() {
    this.goToRoute()
  },
  methods: {
    goToRoute() {
      window.location.href = process.env.VUE_APP_BASKET_URL
    },
  },
}
</script>
<style lang="scss" scoped></style>
